import axios from 'axios'
import { Message } from 'element-ui'

// 创建axios实例
const request = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '', // 开发环境使用空字符串，通过代理转发
  timeout: 10000
})

// 请求拦截器
request.interceptors.request.use(
  config => {
    // 添加token到请求头
    const adminToken = localStorage.getItem('adminToken')
    if (adminToken) {
      config.headers.Authorization = `Bearer ${adminToken}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response) {
      const { status, data } = error.response
      
      // 处理401未授权错误（token过期或无效）
      if (status === 401) {
        // 清除本地存储的token
        localStorage.removeItem('adminToken')
        
        // 显示提示信息
        Message.error('登录已过期，请重新登录')
        
        // 跳转到登录页面
        setTimeout(() => {
          window.location.href = '/yuanhui66-login'
        }, 1500)
        
        return Promise.reject(error)
      }
      
      // 处理其他错误
      Message.error(data.message || '请求失败')
    } else {
      Message.error('网络错误，请检查网络连接')
    }
    
    return Promise.reject(error)
  }
)

export default request 